import { Component, OnInit, AfterViewInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { LwAverageDailyTempGraph } from '../../lw-graphs/average-daily-temp';
import { DemoAccountService } from '../../../demo-account.service';
import { time } from '../../../services/global-variables.service';
import { ChartJsAverageTemperatureGraph } from '../../lw-graphs/chart-js-average-temp';
import { Chart } from 'chart.js';
@Component({
    selector: 'lds-y3-avg-daily-temp',
    templateUrl: './y3-avg-daily-temp.component.html',
    styleUrls: ['./y3-avg-daily-temp.component.css'],
    standalone: false
})
export class Y3AvgDailyTempComponent implements OnInit, OnChanges, OnDestroy {
  @Input() data: any;
  @ViewChild('graph', {static: false}) graphArea: ElementRef;
  graph: any;
  loading = true;
  demoValue;
  constructor(private demo: DemoAccountService) { }

  ngOnInit() {
  }

  ngOnDestroy(){
    if(this.graph){
      this.graph.destroy();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const chartExists = Chart.getChart("averageTemp");
    if(chartExists){
      chartExists.destroy();
    }

    if (changes.data && !changes.data.firstChange) {
    }

    if (changes.data) {
      changes.data.currentValue
        .subscribe((res: any) => {
          let graph = new ChartJsAverageTemperatureGraph();
          this.loading = false;
          graph.draw(res);
          this.graph = graph.graph;
        });
    }
  }
}
